module.exports = __webpack_public_path__ + "img/nl.ab12638f.svg";